import { __read } from "tslib";
export function getContextFromProps(props, defaultContext) {
    var defaultEntries = Object.entries(defaultContext);
    var entries1 = defaultEntries.map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        return [key, props[key]];
    });
    return Object.fromEntries(entries1);
}
//# sourceMappingURL=getContextFromProps.js.map